// ~/middleware/cookie-consent.global.ts
import { useCookieConsent } from "@/composables/cookies/useCookieConsent";
import { useUiStore } from "@/stores/ui";

export default defineNuxtRouteMiddleware(async (to, from) => { 
  if (import.meta.server) return;

  const uiStore = useUiStore();
  const { getConsent } = useCookieConsent();
  const consent = await getConsent();

  const restrictedPaths = [
    '/play/',
    '/sports',
    '/casino/'
  ];

  const isRestricted = restrictedPaths.some(path => {
    if (path.endsWith('/')) {
      return to.path.startsWith(path);
    }
    return to.path === path;
  });

  if (isRestricted && consent !== 'all') {
    const isDirectLanding = !from.name;

    if (isDirectLanding) {
      uiStore.showCookieAccessModal = true;
      return abortNavigation();
    } else {
      localStorage.setItem('lastAttemptedRoute', to.fullPath);
      return navigateTo('/?showCookieModal=true');
    }
  }
});